import React, { useEffect, useState } from 'react'
import UserLayout from '../../layouts/UserLayout'
import UserTabs from '../../components/UserTabs'
import { useDispatch, useSelector } from 'react-redux'
import { Box, useMediaQuery } from '@mui/material'
import { useParams } from 'react-router-dom'
import CreateOrderForm from '../../components/CreateOrderForm'
import CreateOrderButton from '../../components/CreateOrderButton'
import FilterByTag from '../../components/FilterByTag'
import Loading from '../../components/Loading'
import { currentUserActions, filterByTagActions, updateFormActions } from '../../redux/store'
import { selectStores } from '../../redux/slices/storeSlice'
import { setActingStore } from '../../utils/actingStore'

// Admin/director/assistant work a store's board exactly like its staff: same tabs and actions,
// acting as a member of that store. Which actions show is still decided by their permissions.
export default function AdminTask() {
	const dispatch = useDispatch()
	const { storeId } = useParams()
	const { showUpdateForm } = useSelector((state) => state.updateForm)
	const { showFilterByTag } = useSelector((state) => state.filterByTag)
	const { currentUser } = useSelector((state) => state.currentUser)
	const stores = useSelector(selectStores)
	const storeName = stores?.find((store) => store._id === storeId)?.name
	const mediaMd = useMediaQuery('(min-width:768px)')
	const [showForm, setShowForm] = useState(false)

	useEffect(() => {
		setActingStore(storeId)
		dispatch(currentUserActions.actAsStore({ store: storeId }))
		dispatch(filterByTagActions.getAdminStore(storeId))
		return () => {
			setActingStore(null)
			dispatch(currentUserActions.stopActingAsStore())
		}
	}, [dispatch, storeId])

	// The store list may arrive after mount; fill in the name without re-entering the store
	useEffect(() => {
		if (storeName) dispatch(currentUserActions.actAsStore({ store: storeId, storeName }))
	}, [dispatch, storeId, storeName])

	const handleShowForm = (boolean) => {
		setShowForm(boolean)
	}

	const handleShowUpdateForm = () => {
		dispatch(updateFormActions.hideUpdateForm())
		dispatch(updateFormActions.editOrder(null))
	}

	if (currentUser.store !== storeId) {
		return (
			<UserLayout>
				<Loading />
			</UserLayout>
		)
	}

	return (
		<UserLayout>
			<UserTabs />
			<Box
				position='fixed'
				sx={{
					bottom: 0,
					left: mediaMd ? 300 : 0,
					right: 0,
				}}>
				{showFilterByTag && currentUser.permission?.includes('filterByTag') && <FilterByTag />}
				{showUpdateForm && currentUser.permission?.includes('updateOrder') && (
					<CreateOrderForm handleShowForm={handleShowUpdateForm} open={showUpdateForm} storeId={storeId} />
				)}
				{showForm && !showUpdateForm && !showFilterByTag && currentUser.permission?.includes('createOrder') && (
					<CreateOrderForm handleShowForm={handleShowForm} open={showForm} storeId={storeId} />
				)}
				{!showForm && !showUpdateForm && !showFilterByTag && currentUser.permission?.includes('createOrder') && (
					<CreateOrderButton setShowForm={setShowForm} />
				)}
			</Box>
		</UserLayout>
	)
}
